module.exports = __webpack_public_path__ + "img/iconfont.6d6e5731.svg";